import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useMutation } from '@apollo/client/react'
// components
import LocationsTree from 'components/PageComponents/Settings/Locations/components/Tree'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import BusinessEntityModal from 'components/Modals/BusinessEntityModal'
import { CreateLocationButton } from 'components/CTAs'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { LOCATIONS_SELECT_QUERY } from 'graphql/locations/queries'
import { LOCATION_CREATE_MUTATION, LOCATION_UPDATE_MUTATION } from 'graphql/locations/mutations'
// context
import { LocationAPIContext } from 'containers/Locations/layers/API'
// constants
import { ENTITIES } from 'constants/entities'
// utils
import { locationProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Locations: React.FC = () => {
  const [createMutation] = useMutation(LOCATION_CREATE_MUTATION)
  const [updateMutation] = useMutation(LOCATION_UPDATE_MUTATION)

  const { refetch, lastPosition, isLoading } = React.useContext(LocationAPIContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Locations</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} CTA={<CreateLocationButton />}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <LocationsTree />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>

      <BusinessEntityModal
        {...locationProps}
        refetch={refetch}
        lastPosition={lastPosition}
        entityType={ENTITIES.LOCATION}
        query={LOCATIONS_SELECT_QUERY}
        createMutation={createMutation}
        updateMutation={updateMutation}
      />
    </>
  )
}

export default Locations
